import mitt from "mitt";
const emitter = mitt();

export const bvBus = emitter;

const eventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
  emitter,
};

export function initEventBus(app) {
  app.config.globalProperties.$eventBus = eventBus;
}

export default eventBus;
